import React from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import CalculateChargesContent from './CalculateChargesContent';

const CalculateCharges = ({
    fees,
    moduleType,
    moduleId,
    isWaitingList,
    spaces,
    hideFooterTotal,
}: {
    fees: any;
    moduleType: any;
    moduleId: any;
    isWaitingList?: boolean;
    spaces: any[];
    /** Hide the final Total row (e.g. when total is shown in an accordion header). */
    hideFooterTotal?: boolean;
}) => {
    return (
        <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{
                width: '100%',
            }}
        >
            <CalculateChargesContent
                fees={fees}
                moduleId={moduleId}
                moduleType={moduleType}
                isWaitingList={isWaitingList}
                spaces={spaces}
                hideFooterTotal={hideFooterTotal}
            />
        </Grid>
    );
};

export default CalculateCharges;
